module.exports = __webpack_public_path__ + "img/62.5b82de4a.jpg";